module.exports = __webpack_public_path__ + "img/information.a99fea29.png";